import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ variant = "light" }) {
    const [first_name, setFirst] = useState("");
    const [last_name, setLast] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const dark = variant === "dark";

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API}/newsletter`, { first_name, last_name, email });
            toast.success("Welcome aboard. You're subscribed.");
            setFirst("");
            setLast("");
            setEmail("");
        } catch (err) {
            const msg = err?.response?.data?.detail || "Subscription failed. Please try again.";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    const inputBase = dark
        ? "bg-transparent border-b border-[#6d91ad]/50 text-[#fbf9f8] placeholder:text-[#e3c7b9]/40 focus:border-[#ffb5ab]"
        : "bg-transparent border-b border-[#0c0f3d]/30 text-[#0c0f3d] placeholder:text-[#0c0f3d]/40 focus:border-[#e47a6a]";

    const btnBase = dark
        ? "bg-[#ffb5ab] text-[#0c0f3d] hover:bg-[#fbf9f8]"
        : "bg-[#0c0f3d] text-[#fbf9f8] hover:bg-[#e47a6a]";

    return (
        <form onSubmit={submit} className="space-y-5" data-testid="newsletter-form">
            <div className="grid grid-cols-2 gap-5">
                <input
                    type="text"
                    required
                    value={first_name}
                    onChange={(e) => setFirst(e.target.value)}
                    placeholder="First name"
                    className={`w-full font-sans text-sm py-3 outline-none transition-colors ${inputBase}`}
                    data-testid="newsletter-firstname-input"
                />
                <input
                    type="text"
                    required
                    value={last_name}
                    onChange={(e) => setLast(e.target.value)}
                    placeholder="Last name"
                    className={`w-full font-sans text-sm py-3 outline-none transition-colors ${inputBase}`}
                    data-testid="newsletter-lastname-input"
                />
            </div>
            <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address"
                className={`w-full font-sans text-sm py-3 outline-none transition-colors ${inputBase}`}
                data-testid="newsletter-email-input"
            />
            <button
                type="submit"
                disabled={loading}
                className={`group inline-flex items-center gap-3 px-6 py-3 text-xs uppercase tracking-[0.2em] font-medium transition-colors duration-300 disabled:opacity-50 ${btnBase}`}
                data-testid="newsletter-submit-btn"
            >
                {loading ? "Subscribing..." : "Subscribe"}
                <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </button>
        </form>
    );
}
